import React, { useEffect, useRef } from 'react';
import c from 'classnames';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { UnregisterCallback } from 'history';
import { useTranslation } from 'react-i18next';
import { history } from 'instantsearch.js/es/lib/routers';

import { Breadcrumbs } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { BREADCRUMBS_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity';

import SearchResults from './Results';
import { SearchAllContent } from '../../components';

const Search: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const routerHistory = useHistory();

  const classNames = c('Search', 'mt-10');

  const removeHistoryListener = useRef<UnregisterCallback>();

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  useEffect(() => {
    dispatch({
      type: BREADCRUMBS_LOADED,
      payload: [
        {
          title: 'Home',
          url: '/',
        },
        {
          title: 'Zoeken',
        },
      ],
    });
  }, [dispatch]);

  return (
    <div className={classNames}>
      <Container className="mt-6 mb-6">
        <Breadcrumbs />
      </Container>
      <SearchAllContent routing={routing}>
        <Container>
          <h1>{t('pages.search.title')}</h1>

          <div className="mb-10">
            <div className="row">
              <div className="col-12">
                <SearchAllContent.SearchBar autoSearch timeout={300} />
              </div>
            </div>
          </div>

          <SearchResults />
        </Container>
      </SearchAllContent>
    </div>
  );
};

export default Search;
